export const AdyenPaymentErrors = {
  MALFORMED_PRICE: 'malformed-price',
  CANCELLED_TRANSACTION: 'cancelled-transaction',
  CREATING_ORDER_FAILED: 'creating-order-failed',
  UNPROCESSABLE_ENTITY: 'unprocessable-entity',
  PAYMENT_ERROR: 'payment-error',
};
